/**
 * This hook is a simple wrapper around the `react-i18next` <a href="https://react.i18next.com/latest/usetranslation-hook" target="_blank">useTranslation Hook</a>.
 *
 * It uses `useTranslation` and `TFunction`.
 *
 * @module
 */
import { useTranslation as reactI18nextUseTranslation, } from 'react-i18next';
/**
 *
 * # useTranslation
 *
 * Example:
 *
 * English localisation file `localisations/en/lang.json`:
 * ```json
 * {
 *     "message": {
 *         "hello": "Hi there! 👋",
 *         "goodbye": "Farewell!"
 *     }
 * }
 * ```
 * Spanish localisation file `localisations/es/lang.json`:
 * ```json
 * {
 *     "message": {
 *         "hello": "¡Hola! 👋",
 *         "goodbye": "¡Despedida!"
 *     }
 * }
 * ```
 *
 * `t: TFunction` is destructured from useTranslation. It is a function you pass the path of your localisation string to:
 *
 * ```javascript
 * import useTranslation from '@elevio/kb-kit/lib/hooks';
 * const { t } = useTranslation();
 *
 * // Usage:
 * const goodByeMessage: string = t('messages.goodbye', 'So long!');
 * // Outputs "Farewell!" or "¡Despedida!".
 * // If a key like `messages.goodbye` is missing, an optional fallback of 'So long!' would be returned.
 * ```
 *
 *
 * Example usage within a copmonent:
 * ```javascript
 * import useTranslation from '@elevio/kb-kit/lib/hooks';
 *
 * const MyComponent = () => {
 *   const { t } = useTranslation();
 *   const helloMessage = t('messages.hello', 'Oh hello there!');
 *   // Note that the second argument of `t` function is an optional fallback value, in this case 'Oh hello there!'
 *
 *   return <div>{helloMessage}</div>;
 * };
 * ```
 *
 * If you visit `http://localhost:4000/en`, the component will output:
 *
 * > ### Hi there! 👋
 *
 * Whereas if you visit `http://localhost:4000/es`, the component will output:
 *
 * > ### ¡Hola! 👋
 *
 */
export const useTranslation = reactI18nextUseTranslation;
//# sourceMappingURL=useTranslation.js.map